import { createRoot } from "react-dom/client";
import { useEffect } from "react";
import App from "./App.tsx";
import { ErrorBoundary } from "./components/ErrorBoundary";
import { installChunkRecovery, guardAgainstStaleServiceWorkers } from "./lib/chunkRecovery";
import { getBrowserLabel } from "./lib/browserEnv";
import "./index.css";

// Install browser-compat hardening as early as possible.
installChunkRecovery();
guardAgainstStaleServiceWorkers();
try {
  // eslint-disable-next-line no-console
  console.info("[Boot] browser:", getBrowserLabel());
} catch {
  /* noop */
}

// Signal to the bootstrap watchdog in index.html that React has mounted.
function MountSignal() {
  useEffect(() => {
    try {
      const fn = (window as any).__sayItNowMounted;
      if (typeof fn === "function") fn();
    } catch {
      /* noop */
    }
  }, []);
  return <div data-app-mounted="true" style={{ display: "contents" }} />;
}

try {
  const rootEl = document.getElementById("root");
  if (!rootEl) throw new Error("Root element missing");

  createRoot(rootEl).render(
    <ErrorBoundary>
      <MountSignal />
      <App />
    </ErrorBoundary>,
  );
} catch (err) {
  console.error("[main] Failed to bootstrap React:", err);
  try {
    (window as any).__sayItNowFail?.("bootstrap-throw");
  } catch {
    /* noop */
  }
}
